import { Provider } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { history } from "utils/history";
import { Analytics } from "@vercel/analytics/react";
import DeciphrRoutes from "routes";
import store from "store";

function App() {
  history.navigate = useNavigate();
  history.location = useLocation();
  return (
    <Provider store={store}>
      <DeciphrRoutes />
      <Analytics />
    </Provider>
  );
}

export default App;
